import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '@/app/hooks';
import { NavigationActions } from '@/app/slices/navigation';

export enum PageTitleEnum {
  HOME = 'home',
  DONOR_SCHEDULING = 'donorScheduling',
  CHUTE_SCHEDULER = 'chuteScheduler',
  FERTILIZATIONS = 'fertilizations',
  STRIPPING = 'stripping',
  OPU_SEARCH = 'opuSearch',
  CHUTESIDE = 'aspiration',
  SEMEN_PULL = 'semenPull',
  SHIPPING = 'shipping',
  SHIPMENT = 'shipment',
  CALF_ENTRY = 'calfEntry',
  LEGACY_APPS = 'legacyApps',
  FRESH_SHIPMENT = 'freshShipment',
}

const usePageTitle = () => {
  const dispatch = useAppDispatch();
  const { pageTitle } = useAppSelector((state) => state.navigation);

  const setTitle = useCallback(
    (newPageTitle: PageTitleEnum | string, newBrowserTitle?: string) => {
      if (!newBrowserTitle) {
        document.title = `${newPageTitle} | ${import.meta.env.VITE_APP_NAME}`;
        dispatch({
          type: NavigationActions.UPDATE_PAGE_TITLE,
          pageTitle: newPageTitle,
        });
      } else {
        document.title = `${newBrowserTitle} | ${import.meta.env.VITE_APP_NAME}`;
        dispatch({
          type: NavigationActions.UPDATE_PAGE_TITLE,
          pageTitle: newPageTitle,
        });
      }
    },
    [dispatch],
  );

  return { setTitle, pageTitle: pageTitle as string | undefined };
};

export default usePageTitle;
